module.exports = __webpack_public_path__ + "static/20-c5f366b90fe74af8f60b138d302101ca.jpg";